<!-- 添加为商品 -->
<template>
    <div id="">
        <el-form :model="formData" :rules="rules" ref="formData" label-width="110px">
            <div class="form-main">
                <div class="form-left">
                    <el-form-item label="商品分类">
                        <div class="search-item goods-categories">
                            <el-input
                                    readonly
                                    v-model="typeName"
                                    @click.stop.native="showCategories()"
                                    placeholder="请输选择商品类型">
                            </el-input>
                            <div class="categories-tree" v-show="categoriesShow">
                                <chooseGoodsType @chooseNode="chooseNode"></chooseGoodsType>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="商品名称" prop="GoodName">
                        <el-input v-model.trim="formData.GoodName" ></el-input>
                    </el-form-item>
                    <el-form-item label="商城价格" prop="Price">
                        <el-input v-model.number="formData.Price" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="市场价格" prop="MarketPrice">
                        <el-input v-model.number="formData.MarketPrice" type="number"></el-input>
                    </el-form-item>
                </div>
                <div class="form-right">
                    <el-form-item label=" 成本价格" prop="CostPrice">
                        <el-input v-model.number="formData.CostPrice" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="产地">
                        <el-input v-model.trim="formData.Origin"></el-input>
                    </el-form-item>
                    <el-form-item label="库存" prop="Inventory">
                        <el-input v-model="formData.Inventory" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="是否原厂">
                        <el-radio-group v-model="formData.IsOriginal">
                            <el-radio :label='vTrue'>是</el-radio>
                            <el-radio :label='vFalse'>否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <el-form-item label="商品主要图片">
                <uploadFile
                        ref="uploadFile"
                        type="EntpTempGoods"
                        @uploadSuccess="uploadMainSuccess"
                ></uploadFile>
            </el-form-item>
            <el-form-item label="商品描述">
                <quillEditor
                        v-model.trim="formData.GoodDesc"
                        ref="myQuillEditor"
                        :options="editorOption"
                >
                </quillEditor>
            </el-form-item>
        </el-form>
        <div class="dialog-footer">
                <el-button type="primary" @click="submitForm">立即提交</el-button>
                <el-button @click="cancel()">取消</el-button>
        </div>
        <el-dialog
                width="60%"
                title="选择商品类型"
                :visible.sync="innerVisible"
                append-to-body>
            <div>
                <goodType @getGoodsType="getGoodsType"></goodType>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import {quillEditor} from 'vue-quill-editor'
    import quillConfig from '../../../assets/js/quill-config.js'
    import goodType from '@/components/business/search/goodType.vue'
    import chooseGoodsType from '@/components/common/chooseGoodsType.vue'
    import uploadFile from '@/components/common/uploadFile.vue'
    export default {
        name: '',
        props:{
            goodMsg:Object,
            type:String, // 判断是新增还是编辑
        },
        components: {
            goodType,
            quillEditor,
            chooseGoodsType,
            uploadFile
        },
        data(){
            let checkInt = this.$util.checkInt
            return {
                editorOption: quillConfig, // 富文本编辑器配置
                typeName:'',
                innerVisible:false,  // 内层dilog
                tokenData:{
                    token:'',
                    key:''
                }, // 上传图片时带的token
                url:this.$util.QN_UPLOAD_URL, // 服务器地址
                vTrue:true,
                vFalse:false,
                formData:{
                    CateId:'',  // 分类id
                    GoodName:'',
                    GoodDesc:'',
                    Price:'',
                    MarketPrice:'',
                    CostPrice:'',
                    MainImg:'',  // 主要图片后缀
                    IsOriginal:true,
                    APId:'', //汽配Id
                    Inventory:'',// 库存
                    Origin:'',
                },
                rules: {
                    CateId: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                    ],
                    GoodName: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                    ],
                    EnName: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                    ],
                    GoodDesc: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                    ],
                    MainImg: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                    ],
                    HistoryMinPrice: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                        {required: false,validator:checkInt, trigger: 'blur'},
                    ],
                    HistoryMaxPrice: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                        {required: false,validator:checkInt, trigger: 'blur'},
                    ],
                    Price: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                        {required: false,validator:checkInt, trigger: 'blur'},
                    ],
                    MarketPrice: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                        {required: false,validator:checkInt, trigger: 'blur'},
                    ],
                    CostPrice: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                        {required: false,validator:checkInt, trigger: 'blur'},
                    ],
                    Size: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                        {required: false,validator:checkInt, trigger: 'blur'},
                    ],
                    Quality: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                        {required: false,validator:checkInt, trigger: 'blur'},
                    ],
                    Brand: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                    ],
                    Unit: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                    ],
                    Inventory: [
                        {required: true, message: '该项必填', trigger: 'blur'},
                        {required: false,validator:checkInt, trigger: 'blur'},
                    ],
                },
                dialogVisible:false,
                categoriesShow:false
            }
        },
        mounted(){
            this.fillingData();
            window.onclick = ()=> {
                this.categoriesShow = false
            }
        },
        watch:{
            goodMsg(){
                this.fillingData();
            }
        },
        methods:{
            showCategories(){
                this.categoriesShow = true
            },
            // 选中商品分类
            chooseNode(data){
                this.formData.CateId = data.Item.Id
                this.typeName = data.Item.Name
                this.dialogVisible = false
                this.categoriesShow = false
            },
            resetFrom(){
                this.$refs.uploadFile.clearData()
                this.$refs.formData.clearValidate();
            },
            onEditorChange({quill, html, text}) {
                console.log('editor change!', quill, html, text)
                this.content = html
            },
            cancel(){
                this.$emit('closeDialog')
            },
            // 获取商品类型
            getGoodsType(data){
                this.formData.CateId = data.Item.Id
                this.typeName = data.Item.Name
                this.innerVisible = false
            },
            // 显示内层弹窗
            showInnerDialog(){
                this.innerVisible = true
            },
            // 提交表单
            submitForm() {
                let formName = 'formData';
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        // 添加为商品
                        if(this.type == 'add'){
                            this.axios.post('/ERPGood/AddGood', this.formData)
                                .then((response)=> {
                                    this.tokenData.token = response.data.data.token;
                                    this.tokenData.key = response.data.data.imgKeys[0]
                                    this.$refs.uploadMain.submit();
                                })
                                .catch((error)=>{
                                    console.log(error);
                                    this.$message({
                                        message: '添加商品失败',
                                        type: 'error'
                                    });
                                });
                        }
                        // 编辑商品
                        else if(this.type == 'edit'){
                            let _formData = {...this.formData}
                            _formData.APId =this.goodMsg.Id
                            this.axios.post('/ERPGood/UpdateGood', _formData)
                                .then((response)=> {
                                    this.$message({
                                        message: '修改商品成功',
                                        type: 'success'
                                    });
                                    this.$emit('loadData',)
                                })
                                .catch((error)=>{
                                    console.log(error);
                                });
                        }

                    }
                    else {
                        return false;
                    }
                });
            },
            resetForm() {
                let formName = 'formData';
                this.$refs[formName].resetFields();
            },
            // 上传主要图片成功后执行
            uploadMainSuccess(res){
                this.formData.MainImg = res
            },
            // 上传失败
            uploadErr(){
                this.$message.error('上传失败');
            },
            // 上传次要图片成功后
            uploadOtherSuccess(){
                this.$message({
                    message: '转为商品成功',
                    type: 'success'
                });
                // 关闭弹窗
                this.$emit('closeDialog')
            },
            // 填充数据
            fillingData(){
                this.formData = {...this.goodMsg}
                this.$refs.uploadFile.initfileList(this.goodMsg.MainImg)
            },
            // 删除上传
            handleRemove(file, fileList) {
                // console.log(file, fileList);
            },
            handlePreview(file) {
                // console.log(file);
            },
            getFileType(fileName){
                let fileType = fileName.substr(fileName.lastIndexOf(".")+1);
                return fileType
            },
        }
    }
</script>
<style lang="less" scoped>
    .dialog-footer {
        text-align: right;
        margin-right: 20px;
    }
    .prv-ctn {
        display: flex;
        padding-top: 10px;
    }
    .preview-image {
        position: relative;
        img {
            width: 80px;
            height: 80px;
        }
        margin-right: 10px;
        i {
            font-size: 20px;
            color: @font3Color;
            position: absolute;
            top: 0;
            right: 0;
            cursor: pointer;
        }
    }
    .ops-ctn {
        padding-top: 10px;
        display: flex;
        justify-content: space-around;
    }
    .carType-ctn {
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        min-height: 40px;
        padding: 10px;
        display: flex;
        align-items: center;
    }
    .carTypeItem {
        padding: 0 5px;
        height: 24px;
        line-height: 24px;
        border: 1px solid @theme;
        color: @theme;
        margin-right: 10px;
    }
    .carTypeItem-show {
        display: inline-block;
    }
    .form-main {
        display: flex;
    }
    .form-left,.form-right {
        width: 50%;
        margin-right: 20px;
    }
</style>
